<template>
  <div class="con" style="height: 650px;">
    <div id="banner_video">
      <video id="video_banner" src="@/assets/video/esignIndex-newbattle.mp4" autoplay="" muted="" loop=""></video>
      <img class="video_img" src="https://www.esign.cn/images/banner_img.png" alt="" />
    </div>
    <div class="mask">
      <h3 class="name wow fadeInUp" data-wow-delay="50ms">签合同<span class="iconfont icon-yuandian1"></span>用e签宝</h3>
      <div class="btn_group wow fadeInUp" data-wow-delay="150ms">
        <!-- <a href="https://h5.esign.cn/usercenterFront/regist?pub=esign" class="register">注册有礼</a> -->
        <div class="register" @click="dialogShow">免费试用</div>
      </div>
      <div class="num-box container">
        <div class="item wow fadeInUp" data-wow-delay="200ms">
          <div class="itemi">
            <div class="num">
              <strong>
                <span id="zsnum" class="counter" data-counter-time="5000" data-counter-delay="50">{{ numberList[0] }}</span>
              </strong>
              &nbsp;亿张
            </div>
            <p class="msg">节约纸张数&nbsp;(年度)</p>
          </div>
        </div>
        <div class="item wow fadeInUp" data-wow-delay="250ms">
          <div class="itemi">
            <div class="num">
              <strong>
                <span id="wsnum" class="counter" data-counter-time="5000" data-counter-delay="50">{{ numberList[1] }}</span>
              </strong>
              &nbsp;亿元
            </div>
            <p class="msg">节约物流成本&nbsp;(年度)</p>
          </div>
        </div>
        <div class="item wow fadeInUp" data-wow-delay="300ms">
          <div class="itemi">
            <div class="num">
              <strong>
                <span id="tsnum" class="counter" data-counter-time="5000" data-counter-delay="5000">{{ numberList[2] }}</span>
              </strong>
              &nbsp; 万吨
            </div>
            <p class="msg">减少碳排放量&nbsp;(年度)</p>
          </div>
        </div>
      </div>
      <!-- v-if="!isGuangshou" 门户1027迭代紧急需求，影响面大-->
      <div class="count wow fadeInUp" data-wow-delay="350ms" v-if="!isGuangshou">
        <div class="a" @mouseover="showQr" @mouseleave="hideQr">
          e签宝公益林
          <div class="qr-img upshow" v-show="qrShow">
            <img :src="qrImgUrl" alt="" />
            <p>支付宝扫码查看</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    numberList: Array,
    qrImgUrl: String,
  },
  data() {
    return {
      qrShow: false,
      openSwitch: 0,
    }
  },
  computed: {
    // 门户1027紧急需求，在https://guangzhou.esign.cn/sempc地址页面下，e签宝公益林文案及二维码隐藏
    isGuangshou() {
      return window.location.hostname === 'guangzhou.esign.cn' && window.location.pathname === '/sempc'
    },
  },
  methods: {
    showQr() {
      console.log('????')
      this.qrShow = true
    },
    hideQr() {
      console.log('!!!')
      this.qrShow = false
    },
    dialogShow() {
      this.$emit('showDialog')
    },
  },
}
</script>

<style lang="less" scoped>
.con {
  height: 600px;
  position: relative;
}
.video_img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 600px;
  z-index: 1;
}
#banner_video {
  width: 100%;
  height: 600px;
  background: #000;
  #video_banner {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: fill; // 重点
    z-index: 2;
  }
  // 	overflow: hidden;

  // 	position: fixed;
  // 	top: 0;
  // 	left: 0;
  // 	z-index: -1;
}
.mask {
  height: 100%;
  background-color: rgba(24, 31, 60, 0.6);
  padding-bottom: 30px;
  position: absolute;
  height: 650px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
  /* background: no-repeat center / cover url(https://www.esign.cn/images/index_pc_banner.png); */
}
.name {
  text-align: center;
  font-size: 50px;
  font-weight: 500;
  color: #ffffff;
  line-height: 70px;
  padding-top: 60px;
  margin-bottom: 30px;
}
.iconfont {
  font-size: 40px !important;
}
.icon-yuandian1 {
  display: inline-block;
  width: 40px;
  height: 40px;
  background: url('../../../../assets/images/dot.png');
  background-size: contain;
  background-repeat: no-repeat;
}
.btn_group {
  font-size: 0;
  text-align: center;
}
.btn_group div.register {
  background: #e61717;
  border-color: #e61717;
  cursor: pointer;
}
.btn_group .register {
  width: 120px;
  line-height: 38px;
  height: 40px;
  color: #fff;
  border: 1px solid #fff;
  background: transparent;
  display: inline-block;
  transition: all 0.4s ease-in-out;
  font-size: 16px;
}
.num-box {
  display: flex;
  padding-top: 80px;
  padding-bottom: 115px;
  .item {
    width: 33.33%;
    text-align: center;
    font-size: 0;
    .itemi {
      display: inline-block;
      text-align: left;
    }
    .num {
      font-size: 26px;
      font-weight: 400;
      color: #ffffff;
      line-height: 37px;
      margin-bottom: 4px;
      strong {
        font-size: 3.2vw;
        color: #ffffff;
        line-height: 69px;
      }
    }
    .msg {
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      line-height: 26px;
      text-align: center;
    }
  }
}
.count {
  text-align: center;
  .a {
    cursor: default;
    font-size: 16px;
    color: #fff;
    transition: all 0.4s ease-in-out;
    position: relative;
    display: inline-block;
    &:hover {
      color: #e61717;
      &::after {
        background-color: #e61717;
      }
    }
    .qr-img {
      width: 140px;
      margin-left: -70px;
      position: absolute;
      bottom: 40px;
      left: 50%;
      transition: all 0.4s ease-in-out;
      background: #fff;
      img {
        display: block;
        width: 100%;
        height: auto;
        border: none;
      }
      p {
        color: #333;
        font-size: 16px;
        padding-bottom: 10px;
        text-align: center;
      }
    }
  }
  .a::after {
    content: '';
    display: block;
    background: #fff;
    width: 100%;
    margin-top: 4px;
    height: 1px;
    transition: all 0.4s ease-in-out;
  }

  a .qr-img::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    bottom: -8px;
    border: 7px solid transparent;
    border-bottom: 0;
    border-top: 8px solid #fff;
    left: 0;
    right: 0;
    margin: auto;
  }
}
</style>
